import useActiveModel from "../../../stores/useActiveModel.jsx"
import useMainContentTab from "../../../stores/useMainContentTab.jsx"

export default function ThankyouContent() {
    const setMainContentTab = useMainContentTab((state) => state.setMainContentTab)
    const setActiveModel = useActiveModel((state) => state.setActiveModel)
    const startMorphTransition = useActiveModel((state) => state.startMorphTransition)

    return (
        <div className="text-white min-h-svh min-w-svw flex items-center justify-center">
            <div className="mt-[75vh] sm:mt-[75vh]">
                <button
                    className="bg-transparent backdrop-blur-md w-full shadow-glow-md text-white font-bold rounded-sm px-8 py-3 active:shadow-glow-lg pointer-events-auto"
                    onClick={() => {
                        setMainContentTab("StartScreen")
                        startMorphTransition()
                    }}
                >
                    Restart Portfolio
                </button>
            </div>
        </div>
    )
}
